export const createQuiz = /* GraphQL */ `
  mutation createQuiz($input: CreateQuizInput!, $condition: ModelQuizConditionInput) {
  createQuiz(input: $input, condition: $condition) {
      createdAt
      creator
      description
      id
      latestEditor
      meta
      name
      ownerIdAndWsId
      publication_state
      questionsCount
      questionsOrder
      relatedPages
      requiredPassPercentage
      stats
      updatedAt
      version
  }
}
`;

export const createQuizAnswer = /* GraphQL */ `
  mutation createQuizAnswer($input: CreateQuizAnswerInput!, $condition: ModelQuizAnswerConditionInput) {
  createQuizAnswer(input: $input, condition: $condition) {
      answers
      attempt
      completedAt
      duration
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
  }
}
`;

export const createQuizQuestion = /* GraphQL */ `
  mutation createQuizQuestion($input: CreateQuizQuestionInput!, $condition: ModelQuizQuestionConditionInput) {
  createQuizQuestion(input: $input, condition: $condition) {
      id
      options
      ownerIdAndWsId
      quizId
      text
      version
  }
}
`;

export const createQuizStats = /* GraphQL */ `
  mutation createQuizStats($input: CreateQuizStatsInput!, $condition: ModelQuizStatsConditionInput) {
  createQuizStats(input: $input, condition: $condition) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
      userIdAndStatus
  }
}
`;

export const deleteQuiz = /* GraphQL */ `
  mutation deleteQuiz($input: DeleteQuizInput!, $condition: ModelQuizConditionInput) {
  deleteQuiz(input: $input, condition: $condition) {
      createdAt
      creator
      description
      id
      latestEditor
      meta
      name
      ownerIdAndWsId
      publication_state
      questionsCount
      questionsOrder
      relatedPages
      requiredPassPercentage
      stats
      updatedAt
      version
  }
}
`;

export const deleteQuizAnswer = /* GraphQL */ `
  mutation deleteQuizAnswer($input: DeleteQuizAnswerInput!, $condition: ModelQuizAnswerConditionInput) {
  deleteQuizAnswer(input: $input, condition: $condition) {
      answers
      attempt
      completedAt
      duration
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
  }
}
`;

export const deleteQuizQuestion = /* GraphQL */ `
  mutation deleteQuizQuestion($input: DeleteQuizQuestionInput!, $condition: ModelQuizQuestionConditionInput) {
  deleteQuizQuestion(input: $input, condition: $condition) {
      id
      options
      ownerIdAndWsId
      quizId
      text
      version
  }
}
`;

export const deleteQuizStats = /* GraphQL */ `
  mutation deleteQuizStats($input: DeleteQuizStatsInput!, $condition: ModelQuizStatsConditionInput) {
  deleteQuizStats(input: $input, condition: $condition) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
      userIdAndStatus
  }
}
`;

export const updateQuiz = /* GraphQL */ `
  mutation updateQuiz($input: UpdateQuizInput!, $condition: ModelQuizConditionInput) {
  updateQuiz(input: $input, condition: $condition) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on Quiz {
        createdAt
        creator
        description
        id
        latestEditor
        meta
        name
        ownerIdAndWsId
        publication_state
        questionsCount
        questionsOrder
        relatedPages
        requiredPassPercentage
        stats
        updatedAt
        version
      }
  }
}
`;

export const updateQuizAnswer = /* GraphQL */ `
  mutation updateQuizAnswer($input: UpdateQuizAnswerInput!, $condition: ModelQuizAnswerConditionInput) {
  updateQuizAnswer(input: $input, condition: $condition) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on QuizAnswer {
        answers
        attempt
        completedAt
        duration
        id
        ownerIdAndWsId
        quizAndUserId
        quizId
        score
        status
        userId
      }
  }
}
`;

export const updateQuizQuestion = /* GraphQL */ `
  mutation updateQuizQuestion($input: UpdateQuizQuestionInput!, $condition: ModelQuizQuestionConditionInput) {
  updateQuizQuestion(input: $input, condition: $condition) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on QuizQuestion {
        id
        options
        ownerIdAndWsId
        quizId
        text
        version
      }
  }
}
`;

export const updateQuizStats = /* GraphQL */ `
  mutation updateQuizStats($input: UpdateQuizStatsInput!, $condition: ModelQuizStatsConditionInput) {
  updateQuizStats(input: $input, condition: $condition) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on QuizStats {
        answerId
        attempt
        completePercentage
        completedAt
        id
        ownerIdAndWsId
        quizAndUserId
        quizId
        score
        status
        userId
        userIdAndStatus
      }
  }
}
`;
